import React, { ReactElement } from 'react'
import { Card } from 'ktr-materialui-react';
import { makeStyles, Grid } from '@material-ui/core';
import { Route } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';
import values from '../react-intl/FMValues';
import Assistant from './Assistant';
import ProductsOverview from './ProductsOverview';
import * as Utils from '../Utils';
import ClampexChecklist from '../images/Clampex_Checkliste.jpg';
import ClampexRechner from '../images/Clampex_Rechner.jpg';
import Spacecenter from '../images/clampex-assistant-spacecenter.png';
import { Target } from '../Utils';

const useStyle = makeStyles({
    cardLeft: {
        marginRight: "20px",
        height: "300px",
        marginTop: "10px"
    },
    cardRight: {
        marginLeft: "20px",
    }
});

export default function Start(): ReactElement {
    const classes = useStyle();   
    const { formatMessage: f } = useIntl();


    return (
        //app.btn.start
        //buttonText={f({id:'app.btn.start'})}
        <React.Fragment>
            <h1 style={{fontSize: "1.3rem"}}><FormattedMessage id="app.heading" values={values}/></h1>
            <Grid container justify="center">
                <Grid item>
                    <Card
                        className={classes.cardLeft}
                        heading={f({ id: 'app.start.assistant.heading' })}
                        content={<FormattedMessage id="app.assistant.text" values={values}/>}//f({ id: 'app.assistant.text' })}
                        buttonText={f({ id: 'app.btn.start' })}
                        onClick={(event) => Utils.openLink("#/assistant")}
                        imageURL={ClampexChecklist}
                    />
                </Grid>
                <Grid item>
                    <Card
                        className={classes.cardLeft}
                        heading={f({ id: 'app.start.direct.heading' })}
                        content={<FormattedMessage id="app.direct.text" />}//f({ id: 'app.direct.text' })}
                        buttonText={f({ id: 'app.btn.start' })}
                        onClick={(event) => Utils.openLink("#/overview")}
                        imageURL={ClampexRechner}
                    />
                </Grid>
                <Grid item>
                    <Card
                        className={classes.cardLeft}
                        heading={f({ id: 'app.start.spacecenter' })}
                        content={<FormattedMessage id="app.spacecenter.text" />}//f({ id: 'app.direct.text' })}
                        buttonText={f({ id: 'app.btn.start' })}
                        onClick={(event) => Utils.openLink("https://onlinetools.ktr.com/3dweb/ktr_3dspace_login.php", Target.Blank)}
                        imageURL={Spacecenter}
                    />
                </Grid>
            </Grid>
            <Route path="/assistant" component={Assistant}></Route>
            <Route path="/overview" component={ProductsOverview}></Route>
        </React.Fragment>
        

        // clampex-assistant-spacecenter.png
    )
}
